import React from 'react';
import { VideoIcon, ScissorsIcon, BookOpenIcon, TrendingUpIcon, CheckCircleIcon } from 'lucide-react';
export function ContentSection() {
  return <section className="w-full bg-[#faf9f7] py-10 md:py-16 px-4" data-id="element-90">
      <div className="max-w-5xl mx-auto" data-id="element-91">
        <div className="text-center mb-10 md:mb-14" data-id="element-92">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-93">
            La formación incluye
          </h2>
          <div className="w-20 md:w-32 h-1 bg-gradient-to-r from-[#e53935] to-[#ff7043] mx-auto rounded-full" data-id="element-94"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-12" data-id="element-95">
          {/* Bloque 1 */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-gray-100 flex flex-col md:flex-row gap-4 items-start" data-id="element-96">
            <div className="bg-gradient-to-br from-[#e53935]/10 to-[#ff7043]/10 p-3 rounded-xl flex-shrink-0" data-id="element-97">
              <VideoIcon className="w-8 h-8 text-[#e53935]" data-id="element-98" />
            </div>
            <div data-id="element-99">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-100">
                Clases en video paso a paso
              </h3>
              <p className="text-gray-500 leading-relaxed" data-id="element-101">
                Aprendé técnica real observando cada proceso con explicación
                clara.
              </p>
            </div>
          </div>

          {/* Bloque 2 */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-gray-100 flex flex-col md:flex-row gap-4 items-start" data-id="element-102">
            <div className="bg-gradient-to-br from-[#e53935]/10 to-[#ff7043]/10 p-3 rounded-xl flex-shrink-0" data-id="element-103">
              <ScissorsIcon className="w-8 h-8 text-[#e53935]" data-id="element-104" />
            </div>
            <div data-id="element-105">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-106">
                Técnicas profesionales
              </h3>
              <p className="text-gray-500 leading-relaxed" data-id="element-107">
                Fade, degradados, precisión y estructura de corte.
              </p>
            </div>
          </div>

          {/* Bloque 3 */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-gray-100 flex flex-col md:flex-row gap-4 items-start" data-id="element-108">
            <div className="bg-gradient-to-br from-[#e53935]/10 to-[#ff7043]/10 p-3 rounded-xl flex-shrink-0" data-id="element-109">
              <BookOpenIcon className="w-8 h-8 text-[#e53935]" data-id="element-110" />
            </div>
            <div data-id="element-111">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-112">
                Manual completo del método
              </h3>
              <p className="text-gray-500 leading-relaxed" data-id="element-113">
                Una guía técnica que acompaña cada etapa del aprendizaje.
              </p>
            </div>
          </div>

          {/* Bloque 4 */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-gray-100 flex flex-col md:flex-row gap-4 items-start" data-id="element-114">
            <div className="bg-gradient-to-br from-[#e53935]/10 to-[#ff7043]/10 p-3 rounded-xl flex-shrink-0" data-id="element-115">
              <TrendingUpIcon className="w-8 h-8 text-[#e53935]" data-id="element-116" />
            </div>
            <div data-id="element-117">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-118">
                Profesionalización del oficio
              </h3>
              <p className="text-gray-500 leading-relaxed" data-id="element-119">
                Cómo convertir la habilidad en una fuente real de ingresos.
              </p>
            </div>
          </div>
        </div>

        {/* Bloque Para Quién Es */}
        <div className="bg-gradient-to-br from-[#1a1a22] to-[#111116] rounded-2xl p-6 md:p-10 shadow-xl max-w-3xl mx-auto mb-10" data-id="element-120">
          <h3 className="text-2xl font-black text-white mb-6 text-center" data-id="element-121">
            Esta formación es para vos si:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-122">
            {['Querés aprender barbería desde cero', 'Buscás un oficio real para generar ingresos', 'Ya cortás pero querés mejorar tu técnica', 'Soñás con tu propia independencia laboral'].map(item => <div key={item} className="flex items-start gap-3 text-gray-300" data-id="element-123">
                <CheckCircleIcon className="w-5 h-5 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-124" />
                <span className="text-sm md:text-base font-semibold" data-id="element-125">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* CTA Repetido */}
        <div className="flex justify-center" data-id="element-126">
          <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-xl inline-block text-center" aria-label="Quiero ver la formación" data-id="element-127">
            👉 QUIERO VER LA FORMACIÓN
          </a>
        </div>
      </div>
    </section>;
}